import axios from 'axios';

const API_URL = '/api/capacity-assessment';

// Configure axios to send credentials with requests
axios.defaults.withCredentials = true;

const capacityAssessmentService = {
  /**
   * Get saved capacity assessment data
   */
  async getCapacityData() {
    try {
      const response = await axios.get(`${API_URL}/data`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get capacity data'
      };
    }
  },

  /**
   * Save capacity assessment data
   */
  async saveCapacityData(data) {
    try {
      const response = await axios.post(`${API_URL}/save`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to save capacity data'
      };
    }
  }
};

export default capacityAssessmentService;
